import { render } from "./ReportesSap.vue?vue&type=template&id=08a41415&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesSap.vue?vue&type=script&lang=js"
export * from "./ReportesSap.vue?vue&type=script&lang=js"

import "./ReportesSap.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script